export enum QuestionnaireStatusEnum {
    Loaded = 1,
    InProgress = 2,
    Completed = 3
}

export interface IQuestionnaireResponseData {
    Id: any;
    CreatedAt: any;
    UpdatedAt: any;
    Status: any;
    UniqueId: any;
    JsonData: IQuestionnaireResponse[];
}

export interface IQuestionnaireResponse {
    sectionNumber: number;
    sectionText: string;
    subSectionNumber: number;
    subSectionText: string;
    subSectionType?: string;
    questionNumber?: number;
    questionText?: string;
    questionPrefix?: string;
    questionType?: string;
    response?: object;
}

export interface IQuestionnaireAnswer {
    value: any;
    freeText: any;
}

export const EmptyAnswer = (): IQuestionnaireAnswer => ({
    value: null,
    freeText: null
});

export enum EnumQuestionType {
    INPUT = 'INPUT',
    TEXTAREA = 'TEXTAREA',
    DROPDOWN = 'DROPDOWN',
    MONTH = 'MONTH',
    CHOICE = 'CHOICE',
    RATING = 'RATING',
    SCALE = 'SCALE'
}
export enum EnumSectionType {
    Nebeneffekte = 'Nebeneffekte'
}

export enum EnumSectionStatus {
    ACTIVE = "ACTIVE",
    COMPLETED = "COMPLETED"
}

export interface IQuestionnaireSection {
    number: number;
    title?: string;
    status?: EnumSectionStatus | null;
    subSections: IQuestionnaireSubSection[];
    lastUpdated?: any;
    hidden?: boolean;
}

export interface IQuestionnaireSubSection {
    number: number;
    title?: string;
    answerValue?: string;
    status?: EnumSectionStatus | null;
    questions: IQuestionnaireQuestion[];
    sectionType?: EnumSectionType;
    button?: {
        text: string;
    }
    hasError?: boolean;
    hidden?: boolean;
    required?: boolean;
}

export interface IQuestionnaireQuestion {
    answer: IQuestionnaireAnswer;
    number: number;
    introText?: string;
    prefix?: string;
    title: string;
    description?: string;
    info?: IInfoText;
    questionType: EnumQuestionType;
    placeholder?: string;
    data?: any[];
    required?: boolean;
    hasError?: boolean;
    multiple?: boolean;
    hidden?: boolean;
    hideDivider?: boolean;
    pattern?: RegExp;
    monthObj?: IMonth;
    freeTextInput?: IFreeTextInput;
    conditionalOptions?: IConditionalOptionsObj;
    extraClass?: IExtraClass;
    scaleOption?: IScaleSliderOptions;
    requiredGroup?: EnumRequiredGroup;
}

export enum EnumRequiredGroup {
    Cannabisextrakt = "Cannabisextrakt",
    Cannabisarzneimittel = "Cannabisarzneimittel"
}

export interface IScaleSliderOptions {
    floor: number,
    ceil: number,
    step: number,
    translate: string,
    label: {
        start: string;
        end: string;
    }
}

export interface IExtraClass {
    question?: string;
    introText?: string;
    title?: string;
    description?: string;
    info?: string;
}

export interface IConditionalOptionsObj {
    dependedKey: string;
    options?: IConditionalOptions[];
}

export interface IConditionalOptions {
    label: string;
    options: string[];
}

export enum EnumFreeTextType {
    INPUT = "INPUT",
    TEXTAREA = "TEXTAREA"
}

export interface IFreeTextInput {
    inputType: EnumFreeTextType;
    placeholder?: string;
}

export interface IInfoText {
    title: string;
    description: string;
    position: 'START' | 'END';
}

export interface IMonth {
    minMonth?: Date;
    maxMonth?: Date;
}


export const JaNeinData = ["Ja", "Nein"];
export const AndereErkrankung = "Andere Erkrankung (Freitext)";
export const freeTextInputs = [AndereErkrankung];

export const NumberRegex = /^(0|[1-9][0-9]*)$/;
export const DecimalRegex = /^(0|[1-9][0-9]*)(\.[0-9]+)?$/;

export const getMinMonth = (year: number = 1980, month: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 = 0): Date => {
    return new Date(year, month, 1);
}

export const getMaxMonth = (months: number = 0, add: boolean = true): Date => {
    const d = new Date();
    d.setMonth(d.getMonth() + (add ? months : -months) + 1, 0);
    return d;
}

export const isValidDate = (d: any) => {
    return d instanceof Date && !isNaN(d.getTime());
}

export const uniqueStringArr = (value, index, self) => {
    return self.indexOf(value) === index;
}

